import React from "react";

const ShimmerBlock = ({ className }) => (
  <div className={`shimmer rounded-md   ${className}`} />
);

const CustomerDetailShimmer = () => {
  return (
    <section className="relative max-w-7xl mx-auto px-4 py-6 max-h-screen">
      {/* Header shimmer */}
      <div className="flex items-center h-14 mt-5 bg-white px-8 shadow-sm">
        <ShimmerBlock className="h-6 w-6 rounded-full" />
        <ShimmerBlock className="h-6 w-32 mx-auto" />
      </div>

      <div className="px-4 mt-8 space-y-4">
        <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm space-y-6">
          {/* Customer row */}
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              {/* Avatar */}
              <ShimmerBlock className="h-12 w-12 rounded-full" />

              {/* Name + phone */}
              <div className="space-y-2">
                <ShimmerBlock className="h-4 w-40" />
                <ShimmerBlock className="h-3 w-28" />
              </div>
            </div>

            {/* Edit button */}
            <ShimmerBlock className="h-12 w-12 rounded-md" />
          </div>

          {/* Address */}
          <ShimmerBlock className="h-14 w-full" />

          {/* Amount Due */}
          <div className="flex flex-col items-center gap-2">
            <ShimmerBlock className="h-8 w-32" />
            <ShimmerBlock className="h-4 w-24" />
          </div>

          <div className="border-t border-gray-100" />

          {/* Stats */}
          <div className="grid grid-cols-3 divide-x divide-gray-100">
            {[1, 2, 3].map((_, i) => (
              <div key={i} className="py-4 flex flex-col items-center gap-2">
                <ShimmerBlock className="h-5 w-20" />
                <ShimmerBlock className="h-3 w-28" />
              </div>
            ))}
          </div>

          <div className="border-t border-gray-100" />

          {/* Subscription card */}
          <div className="flex justify-between items-center gap-2 w-full border border-gray-200 p-4 rounded-md bg-gray-100">
            <div className="flex gap-2 items-center">
              <ShimmerBlock className="h-5 w-5 rounded" />
              <ShimmerBlock className="h-4 w-36" />
            </div>

            <ShimmerBlock className="h-10 w-24 rounded-md" />
          </div>

          {/* Action buttons */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-4 mt-3">
            {[1, 2, 3, 4].map((_, i) => (
              <ShimmerBlock key={i} className="h-12 w-full rounded-md" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerDetailShimmer;
